import { getFromWeekCinemaEndDate, getFromWeekCinemaStartDate } from '../getDateFromWeek'
import checkPerformanceByTimeRange from './checkPerformanceByTimeRange'

// Cinema week Thursday–Wednesday. getFromWeekCinemaEndDate returns Wednesday at
// 00:00, so the comparison has to happen on day granularity — that is what
// checkPerformanceByTimeRange does, and why the whole Wednesday stays inside the week.
const filterPerformancesByWeek = (performances, weekObj) => {
    const weekPeriodeStartDate = getFromWeekCinemaStartDate(weekObj.isoWeek, weekObj.year)
    const weekPeriodeEndDate   = getFromWeekCinemaEndDate(weekObj.isoWeek, weekObj.year)

    return performances.filter(performance =>
        performance.timeUtc && checkPerformanceByTimeRange(weekPeriodeStartDate, weekPeriodeEndDate, performance)
    )
}

export default filterPerformancesByWeek
